const search = {
    init() {
        this.clickActions.init();
        this.filterActions.init();
    },

    clickActions: {
        init() {
            const searchForms = document.querySelectorAll('[data-search-form]');

            if (searchForms.length) {
                searchForms.forEach(form => {
                    const searchButtons = form.querySelectorAll('[data-search-result-tabs] .nav-search-item');
                    const searchSortTriggers = form.querySelectorAll('[data-search-sort-trigger]');
                    const searchSortDropdowns = form.querySelectorAll('[data-search-sort-dropdown]');
                    const dropdownItems = form.querySelectorAll('.search-sort__dropdown-item');
                    const input = form.querySelector('.search__form-input');
                    const searchResultContainer = form.querySelector('[data-search-result-container]');
                    const searchButton = form.querySelector('[data-search-close]');
                    if (form.classList.contains('openabled')) {
                        const transitionEndHandler = () => {
                            console.log(input, ' transitionEndHandler log')
                            input.focus();
                            form.removeEventListener('transitionend', transitionEndHandler);
                        };
                        form.addEventListener('click', (e) => {
                            if (!e.target.closest('[data-search-result-container]')) {
                                e.stopPropagation();
                                e.preventDefault();

                                if (!form.classList.contains('active')) {
                                    console.log(form, input, ' event log')
                                    form.classList.add('active');
                                    form.addEventListener('transitionend', transitionEndHandler);
                                }
                            }
                        })
                        form.querySelector('[data-search-close]').addEventListener('click', (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            if (form.classList.contains('active')) {
                                form.classList.remove('active');
                                input.value = '';
                                searchResultContainer.classList.add('hidden');
                                searchButton.classList.remove('searching');
                            }
                        })
                        window.addEventListener('click', (e) => {
                            if (!e.target.closest('.search__result')) {
                                if (form.classList.contains('active')) {
                                    form.classList.remove('active');
                                }
                            }
                        })
                    }

                    // работа кнопок фильтров в поиске
                    if (searchButtons.length) {
                        searchButtons.forEach(button => {
                            button.addEventListener('click', (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                
                                searchButtons.forEach(btn => {
                                    btn.classList.remove('active');
                                });
                                
                                button.classList.add('active');
    
                                const form = button.closest('[data-search-form]');
                                const searchSort = form.querySelector('[data-search-sort]');
                
                                if (button.hasAttribute('data-sort-filter-true')) {
                                    searchSort.classList.add('active');
                                } else {
                                    searchSort.classList.remove('active');
                                }
                            });
                        });
                    }

                    if (searchSortTriggers.length) {
                        searchSortTriggers.forEach(trigger => {
                            trigger.addEventListener('click', (e) => {
                                const dropdown = trigger.nextElementSibling;
                                dropdown.classList.toggle('active');
                            });
                        });
                        dropdownItems.forEach(item => {
                            item.addEventListener('click', (e) => {
                                e.stopPropagation();
                                dropdownItems.forEach(item => {
                                    item.classList.remove('active');
                                });
                                searchSortDropdowns.forEach(dropdownItem => {
                                    dropdownItem.classList.remove('active');
                                });
                                searchSortTriggers.forEach(trigger => {
                                    trigger.classList.add('used');
                                })
                                item.classList.add('active');
                            });
                        });
                    }

                    form.addEventListener('keydown', (e) => {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                        }
                    });
                })
            }
        },
    },
    filterActions: {
        init(){
            const searchForms = document.querySelectorAll('[data-searchf-form]');
            if(searchForms.length){
                searchForms.forEach(form => {

                    form.addEventListener('mouseover', (e)=>{
                        if(!form.classList.contains('active')){
                            form.classList.add('active');
                        }
                    })

                    form.addEventListener('mouseout', (e)=>{
                        if(form.classList.contains('active') && form.querySelector('[data-searchf-input]').value === ''){
                            form.classList.remove('active');
                            
                        }
                    })
                    
                    form.addEventListener('click', (e)=>{
                        e.stopPropagation()
                    })

                    window.addEventListener('click', ()=>{
                        if(form.classList.contains('active')){
                            form.querySelector('[data-searchf-result-container]').innerHTML =''
                            form.querySelector('[data-searchf-input]').value = ''
                            form.querySelector('[data-searchf-input]').blur()
                            form.classList.remove('active');
                        }
                    })

                    window.addEventListener('scroll', ()=>{
                        if(form.classList.contains('active')){
                            form.querySelector('[data-searchf-result-container]').innerHTML =''
                            form.querySelector('[data-searchf-input]').value = ''
                            form.querySelector('[data-searchf-input]').blur()
                            form.classList.remove('active');

                        }
                    })
                    form.addEventListener('keydown', (e) => {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                        }
                    });
                })
            }
            const containers = document.querySelectorAll('[data-searchf-mobile-container]')
            if(containers.length){
                containers.forEach(container => {
                    container.addEventListener('touchstart', (e)=>{
                        e.stopPropagation()
                    })

                    window.addEventListener('touchstart', ()=>{
                        if(container.closest('[data-searchf-wrapper]').classList.contains('show')){
                            if(container.querySelector('[data-searchf-result-container]')){
                                container.querySelector('[data-searchf-result-container]').innerHTML = '';
                            }
                            if(container.querySelector('[data-searchf-mobile-input]')){
                                container.querySelector('[data-searchf-mobile-input]').value = '';
                            }
                        }
                    })
                })
            }

        },
    }
}

search.init()